import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';

/**
 * AOT-safe replacement for ngx-filesaver@8 (View Engine only → "JIT compiler unavailable" in prod).
 * Same save(blob, filename) surface used by the app.
 */
@Injectable({
  providedIn: 'root'
})
export class FileSaverService {
  save(blob: Blob | File | string, filename?: string, _options?: unknown): void {
    saveAs(blob as Blob, filename);
  }
}
